// The markdown link element reports empty hrefs so authoring mistakes surface.
// This package stays decoupled from the host's Sentry integration: the host
// wires its reporter once at bootstrap via `setMarkdownErrorReporter`; until
// then (and in tests) reporting is a no-op.
type MarkdownErrorReporter = (errorMessage: string) => void

const noop: MarkdownErrorReporter = () => undefined
let reporter: MarkdownErrorReporter = noop

export function setMarkdownErrorReporter(fn: MarkdownErrorReporter): void {
  reporter = fn
}

export function reportMarkdownError(errorMessage: string): void {
  reporter(errorMessage)
}
